const headers = [
  {
    text: 'id',
    value: 'supplierId',
    sortable: true,
    width: '2%'
  },
  {
    text: 'sale.sale_status',
    value: 'isEnabled',
    sortable: true,
    width: '7%',
    align: 'center'
  },
  {
    text: 'order.order_supplier-name',
    value: 'name',
    sortable: true,
    width: '11%'
  },
  {
    text: 'product.product_vendor-name',
    value: 'abbreviation',
    sortable: true,
    width: '10%'
  },
  {
    text: 'product.product_auxiliary-explanation',
    value: 'description',
    sortable: true,
    width: '10%'
  },
  {
    text: 'common.address_address_0',
    value: 'addressInfo',
    sortable: true,
    width: '11%'
  },
  {
    text: 'storage.storage_contact-address',
    value: 'contactInfo',
    sortable: true,
    width: '13%'
  },
  {
    text: 'order.order_department',
    value: 'section',
    sortable: true,
    width: '8%'
  },
  {
    text: 'order.order_rep',
    value: 'rep',
    sortable: true,
    width: '7%'
  },
  {
    text: 'order.order_suggested-receiving-location',
    value: 'suggestedReceivingLocation',
    sortable: true,
    width: '10%'
  },
  {
    text: 'common.input_payment-criteria',
    value: 'paymentCriteria',
    sortable: true,
    width: '6%'
  },
  {
    text: 'common.input_sort-number',
    value: 'sortNumber',
    sortable: true,
    width: '6%'
  },
  {
    text: 'payment.payment_operation',
    value: 'edit',
    sortable: false,
    width: '6%'
  }
]
export default { headers }
